import React from 'react';
import { faFilter } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

const FilterIcon = () => {
    return (
        <span>
            <FontAwesomeIcon icon={faFilter} />
            &nbsp;
        </span>
    );
};

export default React.memo(FilterIcon);
